import React, { useState, useEffect } from "react";
import axios from "axios";

const ButtonGrid = () => {
  const [buttons, setButtons] = useState([
    { id: 1, name: "Admission", image: "Images/ButtonGrid/admission.png", url: "admission-procedure" },
    { id: 2, name: "Academics", image: "Images/ButtonGrid/image1.png", url: "/academics" },
    { id: 3, name: "Achievers", image: "Images/ButtonGrid/achievers.jpg", url: "" }, // URL to be dynamically updated
    { id: 4, name: "Activities", image: "Images/ButtonGrid/image2.png", url: "/activities" },
    { id: 5, name: "Gallery", image: "Images/ButtonGrid/image3.png", url: "/gallery" },
    { id: 6, name: "Social service", image: "Images/ButtonGrid/image4.png", url: "/social-service" },
  ]);

  const [columns, setColumns] = useState("repeat(3, 1fr)");

  useEffect(() => {
    // Fetch the result link for "Achievers"
    const fetchResultLink = async () => {
      try {
        const response = await axios.get("https://backend-school-914b.onrender.com/result"); // Replace with your backend URL
        const resultLink = response.data.link;

        // Update the "Achievers" button URL dynamically
        setButtons((prevButtons) =>
          prevButtons.map((button) =>
            button.name === "Achievers" ? { ...button, url: resultLink } : button
          )
        );
      } catch (err) {
        console.error("Failed to fetch result link:", err);
      }
    };

    fetchResultLink();

    // Adjust the grid layout based on the screen size
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setColumns("repeat(2, 1fr)"); // For tablet or small screens
      } else {
        setColumns("repeat(3, 1fr)"); // For large screens
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Call initially to set the right columns on load

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const styles = {
    container: {
      display: "grid",
      gridTemplateColumns: columns, // Use dynamic column value
      gap: "16px",
      padding: "46px 0",
      justifyContent: "center",
      justifyItems: "center",
      alignItems: "center",
    },
    button: {
      position: "relative",
      width: "100%",
      maxWidth: "300px",
      height: "150px",
      maxHeight: "150px",
      backgroundSize: "cover",
      backgroundPosition: "center",
      borderRadius: "50px",
      overflow: "hidden",
      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
      cursor: "pointer",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    buttonHover: {
      transform: "scale(1.05)",
      boxShadow: "0 8px 15px rgba(0, 0, 0, 0.2)",
    },
    overlay: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      color: "white",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "20px",
      fontWeight: "bold",
      opacity: 0,
      transition: "opacity 0.3s ease",
    },
    buttonHoveredOverlay: {
      opacity: 1,
    },
  };

  return (
    <div className="button-grid" style={styles.container}>
      {buttons.map((button) => (
        <div
          key={button.id}
          style={{
            ...styles.button,
            backgroundImage: `url(${button.image})`,
          }}
          onClick={() => window.location.href = button.url}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = styles.buttonHover.transform;
            e.currentTarget.style.boxShadow = styles.buttonHover.boxShadow;
            const overlay = e.currentTarget.querySelector(".overlay");
            overlay.style.opacity = styles.buttonHoveredOverlay.opacity;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "";
            e.currentTarget.style.boxShadow = "";
            const overlay = e.currentTarget.querySelector(".overlay");
            overlay.style.opacity = styles.overlay.opacity;
          }}
        >
          <div className="overlay" style={styles.overlay}>
            {button.name}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ButtonGrid;
